import { createFileRoute } from "@tanstack/react-router";
import { PressPage } from "@/pages/proof/ProofPages";
import { seoHead } from "@/lib/seo/head";
export const Route = createFileRoute("/press")({ head: () => seoHead({ path: "/press", title: "Press and Source Hub", description: "Verified LeadXkids facts, teaching approach, research summaries, logos, policies and media contact for journalists and educators." }), component: PressPage });
